import round from "../number/round";

export default function (meters: number, precision = 2) {
  return round(meters * 0.0006214, precision) ?? 0;
}
